import React, { useEffect, useState, useRef } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import '../../../styles/detail-carousel.css';

interface OmOssDetailProps {
  onBack: () => void; // Callback to close the details view
}

const thumbnails = [
  { thumb: '/pictures/honeypictures/bikupor/beehive1_small.webp', targetSlide: 1 },
  { thumb: '/pictures/honeypictures/bikupor/Bikupor2_small.webp', targetSlide: 2 },
  { thumb: '/pictures/honeypictures/bikupor/videointro.webp', targetSlide: 3 },
];

type SlideItem =
  | {
      type: 'text';
      title: string;
      description: React.ReactNode;
    }
  | {
      type: 'image';
      title: string;
      image: string;
      text?: React.ReactNode;
    }
  | {
      type: 'video';
      title: string;
      videoUrl: string;
    };

const OmOssDetails: React.FC<OmOssDetailProps> = ({onBack}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null); // Ref for the modal container

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
    onSelect();
  }, [emblaApi]);

    // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onBack(); // Call the onBack function to close the modal
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onBack]);


const slideContent: SlideItem[] = [
{
    type: 'text',
    title: 'Biodling i Enköping',
    description: (
      <div>
        <h4>Vilka är vi</h4>
        <p>Flera generationer av passionerade biodlare.
        Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?
        Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?
        </p>
        <p>Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?</p>
        <h4>Undertitel?</h4>
        <p>Brödtext här Brödtext här Brödtext här Brödtext här Brödtext här Brödtext här Brödtext här Brödtext här
          Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?
          Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?
          Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor? Text om våra bikupor?
        </p>
        <h4>Undertitel?</h4>
        <p>Brödtext här Brödtext här Brödtext här</p>
      </div>
    ),
  },
  {
    type: 'image',
    title: 'Biodlare Juan och Frank',
    image: '/pictures/honeypictures/biodlare/FrankJuan.webp',
    text: (
      <div>
        <p>
          Frank håller upp sin första ram tillsammans med Morfar Juan. Kanske ha text under bilden istället om det är lite text? En bild på alla biodlarna vi kan samla, Juan,Valdis,Frank,Sofia, etc
        </p>
      </div>
    ),
  },
  {
    type: 'image',
    title: 'Hello world',
    image: '/pictures/honeypictures/bikupor/Bikupor2.jpg',
    text: null,
  },
  {
    type: 'video',
    title: '',
    videoUrl: 'https://www.youtube.com/embed/z2vFogbXVYU?autoplay=1&rel=0',
  },
];

return (
  <div className="detail-overlay-carousel">
    <div className="detail-container-carousel" ref={modalRef}>
      
      {/* Carousel Viewport */}
      <div className="detail-embla__viewport" ref={emblaRef}>
        <div className="detail-embla__container">
          {slideContent.map((content, index) => (
            <div className="detail-embla__slide" key={index}>
              {content.type === 'text' && content.title && (
                <h3 className="text-4xl text-white detail-slide-title">
                  {content.title}
                </h3>
              )}

              {content.type === 'text' && (
                <div className="detail-slide-layout">
                  <div className="detail-slide-text">
                    <div className="detail-slide-description">{content.description}</div>
                  </div>

                  <div className="detail-sidebar">
                    {/* Sidebar content for first slide only */}
                    <div className="sidebar-section">
                      <h4 className="sidebar-title">Bilder & Videos</h4>
                      <div className="detail-thumb-grid">
                        {thumbnails.map((thumb, i) => (
                          <div
                            key={i}
                            className="detail-thumb-carousel"
                            style={{ backgroundImage: `url(${thumb.thumb})` }}
                            onClick={() => emblaApi?.scrollTo(thumb.targetSlide)}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="sidebar-section">
                      <h4 className="sidebar-title">Länkar & Material</h4>
                      <ul className="sidebar-links">
                        <li>
                          <a
                            href="/material/varoa_20250729-1726.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Senaste test av yngelröta
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="sidebar-section">
                      <h4 className="sidebar-title">Viktigt för oss</h4>
                      <ul className="sidebar-checklist">
                        <li>Flera generationer</li>
                        <li>Naturligt material</li>
                        <li>Något kul här</li>
                        <li>Något kul här</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {content.type === 'image' && (
                content.text ? (
                  <div className="detail-slide-image-layout">
                    <div className="relative detail-slide-image">
                      <img
                        src={content.image}
                        alt={content.title || 'Bild'}
                        className="detail-image"
                      />
                      {content.title && (
                        <h3 className="absolute bottom-1 left-1 text-xs text-gray-300 italic bg-black/60 px-1.5 py-0.5 rounded">
                          {content.title}
                        </h3>
                      )}
                    </div>
                    <div className="detail-slide-description detail-slide-description-box [&_h4]:text-left [&_p]:text-left">
                      {content.text}
                    </div>
                  </div>
                ) : (
                  <div className="relative detail-slide-full-image">
                    <img
                      src={content.image}
                      alt={content.title || 'Bild'}
                      className="detail-image"
                    />
                    {content.title && (
                      <h3 className="absolute bottom-1 left-1 text-xs text-gray-300 italic bg-black/60 px-1.5 py-0.5 rounded">
                        {content.title}
                      </h3>
                    )}
                  </div>
                )
              )}




              {content.type === 'video' && selectedIndex === index && (
                <div className="detail-slide-content">
                  <div className="video-wrapper">
                    <iframe
                      src={content.videoUrl}
                      title="YouTube video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              )}

            </div>
          ))}
        </div>
      </div>

      {/* Radio Navigation BELOW the carousel */}
      <div className="radio-nav">
        {slideContent.map((_, index) => (
          <input
            key={index}
            type="radio"
            name="slide-nav"
            checked={selectedIndex === index}
            onChange={() => emblaApi?.scrollTo(index)}
          />
        ))}
      </div>
    </div>
  </div>
);



};

export default OmOssDetails;
